import Swiper from 'swiper/bundle';
import flatpickr from "flatpickr";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import 'swiper/css/bundle'
import './flatpickr_ko';

$(() => {
    $('.tel').on("keyup",function() {
        let prev    = $(this).val();
        let str     = prev.replace(/[^0-9]/g, "").replace(/(^02|^0505|^01.{1}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,"$1-$2-$3").replace("--", "-");
        $(this).val(str);
    });
    // header
    let $data = $('.header').data('nav');
    $('.top-menu>li').removeClass('active').eq($data).addClass('active')
    if($data == 10) $('.page-header').css('height','400')

    $(".rsv-menu").on({
        click:() => $('.rsv-list').slideToggle(),
        mouseenter:() => $('.rsv-list').slideDown(),
        mouseleave:() => $('.rsv-list').slideUp()
    });

    $(window).scroll(() => {
        let mainHeight = $('.main-wrapper, .page-header').innerHeight()
        $('.header, .top-btn').removeClass('active');
        if($(window).scrollTop() > mainHeight) $('.header, .top-btn').addClass('active');

        if($('.topBanner').length){
          $('.topBanner').removeClass('active');
          if($(window).scrollTop() > mainHeight) $('.topBanner').addClass('active');
        }
    })

    var Swipers = [];
    $('.slide, .sub-slide').each(function(i) {
        var r_i = $(this).find('.swiper').attr('id');
        Swipers[i] = new Swiper('#'+r_i, {
            loop: true,
            loopAdditionalSlides : 1,
            navigation: {
                nextEl: ".swiper-button-next."+r_i,
                prevEl: ".swiper-button-prev."+r_i,
            },
            pagination: {
                el: ".swiper-pagination."+r_i,
                clickable: true,
            },
        });
    })

    const groupCheckoutPicker = flatpickr("#checkout", {
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: "ko",
    });

    flatpickr("#checkin", {
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: "ko",
        onChange: (selectedDates) => {
            if (!selectedDates[0]) return;
            const nextDay = new Date(selectedDates[0]);
            nextDay.setDate(nextDay.getDate() + 1);
            groupCheckoutPicker.set("minDate", nextDay);
        },
    });

    $('#tel').on("keyup",function() {
        prev    = $(this).val();
        str     = prev.replace(/[^0-9]/g, "").replace(/(^02|^0505|^01.{1}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,"$1-$2-$3").replace("--", "-");
        $(this).val(str);
    });

    $('.input_price').on('input', function() {
        var value = $(this).val().replace(/[^0-9]/g, '');
        $(this).val(value ? Number(value).toLocaleString() : '');
    });

    const formCheck = ($form) => {
        const $input = $form.find('input, select, textarea');
        let chk = false

        if ($form) {
            $($input).each((i,v) => {
                if(v.value === '' && $(v).attr('data-optional') != "skip" && $(v).attr('type') != "hidden") {
                    alert($(v).data('check'));
                    $(v).focus();
                    chk = false;
                    return false;
                } else{
                    chk = true;
                }
            });
        }
        return chk;
    }

    $("input[type=checkbox]").change((e) => {
        $(e.currentTarget).val($(e.currentTarget).is(':checked') ? 'y' : '')
        if($(e.currentTarget).hasClass('check-it')){
            $(".check-it").toArray().every((v) => $(v).is(':checked')) ? $(".check-all").prop("checked", true) : $(".check-all").prop("checked", false)
        }
    })

    // 페이지 이동시 스크롤 이동
    const params = new URLSearchParams(window.location.search);

    const scrollArea = ($target, $subMenu = 50) => {
        const targetTop = $(`.${$target}`).offset().top - ($('.header').outerHeight()  + $subMenu);
        window.scrollTo({ top: targetTop, left: 0});
    }

    params.get('scroll') && scrollArea(params.get('scroll'));

    // 페이지 이동시 팝업 열기
    const popupOpen = (popup) => {$(`#${popup}`).show()}
    params.get('popup') && popupOpen(params.get('popup'));

    // <---- dining/facil ---->
    $(window).scroll(() => {
        $('.facil-banner').removeClass('active');
        if($(window).scrollTop() > 650) $('.facil-banner').addClass('active');
    })

    $(".facil-btn").click(() => {
        const $form = $('#sms');
        formCheck($form);

        const data = $form.serializeArray(),
            sendData = {};

        for (let i = 0; i < data.length; i++){
            sendData[data[i]['name']] = data[i]['value'];
        }

        fetch('/facilities/sms/store', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(sendData),
        })
        .then((response) => response.json())
        .then((result) => {
            alert('안내문자가 발송되었습니다.')
            self.close();
        })
    })


    flatpickr("#fdate", {
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: "ko",
    });

    $('.facil-wrap .info-btn').click((e) => {
        scrollArea($(e.currentTarget).data('area'))
    })

    // 속초횟집 팝업
    let popStr = localStorage.getItem('o2uDining')
    let popChk = !popStr || popStr != "" && dayjs().format('YYYY-MM-DD') > popStr ? true : false
    popChk ? $('.diningPopup').show() : $('.diningPopup').hide()

    let oneday = dayjs().format('YYYY-MM-DD');
    $('.diningPopup .btn-close').click(() => {
        if($('#today').is(':checked')){
            localStorage.setItem('o2uDining', oneday)
            $('.diningPopup').hide()
        }
    })

    // <---- group ---->
    $('.group-wrap .area-btn').click((e) => {
        scrollArea('area_contact')
    })
    $('.courseTab>li').click((e) => {
        $('.courseTab>li').removeClass('on').eq($(e.currentTarget).index()).addClass('on')
        $('.courseList>li').removeClass('on').eq($(e.currentTarget).index()).addClass('on')
    })
    $('.group-qna .f-q').click((e) => $(e.currentTarget).toggleClass('on').siblings($('.f-a')).toggleClass('on'))

    $('.person input').keyup(function() {
        let value1 = $('#men').val();
        let value2 = $('#women').val();
        $('#person').val(+value1 + +value2);
    })

    $('#grpform #tel1, #grpform #tel2, #grpform #tel3').on('input', function() {
        const maxLength = $(this).attr('maxlength');
        $(this).val($(this).val().replace(/[^0-9]/g, '').slice(0, maxLength));
    })

    // <---- reserveclub ---->
    // let params = new URLSearchParams(window.location.search);
    let slideNum = params.get('slideNum')
    let bullet = ['29', '49', '99'];
    let num = ['1', '1', '2'];
    var rsvSwiper = new Swiper('.rsv-slide .swiper',{
        initialSlide: slideNum ? +slideNum : 0,
        loop: true,
        loopAdditionalSlides : 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletClass:"custom-bullet",
            bulletActiveClass: "custom-bullet-active",
            renderBullet: function (index, className) {
                return `<span class=${className}>리저브 클럽 ${bullet[index]}</span>`;
            },
        },
        on: {
            init : (e) => {
                $('.club-wrap [class^=section]').hide()
                $('.club-wrap [class^=section]').eq(e.realIndex).show()
                $('.club-wrap .table-wrap .num').text(bullet[e.realIndex])
                $('.club-wrap .fold .num').text(num[e.realIndex])
            },
            slideChange : (e) => {
                $('.club-wrap [class^=section]').hide()
                $('.club-wrap [class^=section]').eq(e.realIndex).show()
                $('.club-wrap .table-wrap').removeClass('active-29 active-49 active-99')
                $('.club-wrap .table-wrap').addClass(`active-${bullet[e.realIndex]}`)
                $('.club-wrap .table-wrap .num').text(bullet[e.realIndex])
                $('.club-wrap .fold .num').text(num[e.realIndex])
            },
        },
    });

    $('.club-wrap .fold-tit').click((e) => $(e.currentTarget).siblings('.fold-cnt').slideToggle())

    $('.club-wrap .table-wrap .table [class^=tab]').click((e) => {
        rsvSwiper.slideTo(+$(e.currentTarget).index() -1)
    })

    if($(".club-wrap .swiper-pagination").length){
        const $rsvTab = $(".swiper-pagination");
        const headerHeightWeb = $(".header").innerHeight();
        let initialOffset = $rsvTab.offset().top;
        const updateSticky = () => {
            $rsvTab.toggleClass("active", $(window).scrollTop() >= initialOffset + headerHeightWeb);
        };

        $(window).on("scroll resize", () => {
            updateSticky();
        }).trigger("resize");

        updateSticky();
    }

    // faq

    $('.faq-tit').click((e) => {
        let $this = $(e.currentTarget)
        let $thisInfo = $this.siblings('.faq-desc')
        if($this.hasClass('on')){
            $this.removeClass('on')
            $thisInfo.slideUp()
        }else{
            $thisInfo.slideUp()
            $('.faq-tit').removeClass('on')
            $('.faq-desc').slideUp()
            $this.addClass('on')
            $thisInfo.slideDown()
        }
    })

    // reserve-faq
    const $faqList = document.querySelector('.faq-list');
    const $faqEmpty = document.querySelector('.faq-empty');
    const $faqSearchInput = document.querySelector('.faq-search input');
    let faqFilter = 'all';

    const applyFaqFilter = () => {
        const keyword = ($faqSearchInput?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        document.querySelectorAll('.faq-item').forEach(item => {
            const categoryMatch = faqFilter === 'all' || item.dataset.category === faqFilter;
            const keywordMatch = keyword === '' ||
                item.querySelector('.faq-q-txt').textContent.toLowerCase().includes(keyword) ||
                item.querySelector('.faq-a-inner').textContent.toLowerCase().includes(keyword);
            const visible = categoryMatch && keywordMatch;

            item.style.display = visible ? '' : 'none';
            if (visible) visibleCount++;
        });

        if ($faqList) $faqList.style.display = visibleCount ? '' : 'none';
        if ($faqEmpty) $faqEmpty.style.display = visibleCount ? 'none' : '';
    };

    document.querySelectorAll('.faq-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('.faq-tab').forEach(t => {
                t.classList.remove('active')
            });
            tab.classList.add('active');
            faqFilter = tab.dataset.filter;
            applyFaqFilter();
        });
    });

    document.querySelector('.faq-search button')?.addEventListener('click', applyFaqFilter);
    $faqSearchInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyFaqFilter();
        }
    });

    document.querySelector('.faq-empty .btn-list')?.addEventListener('click', () => {
        document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
        document.querySelector('.faq-tab[data-filter="all"]')?.classList.add('active');
        faqFilter = 'all';
        if ($faqSearchInput) $faqSearchInput.value = '';
        applyFaqFilter();
    });

    document.querySelectorAll('.faq-item').forEach(item => {
        item.addEventListener('click', () => {
            document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
            item.classList.add('active');
        });
    });

    // reserve-qa
    document.getElementById('inquiryFile')?.addEventListener('change', function () {
        const file = this.files[0];
        const nameEl = document.querySelector('.file-name');
        const innerEl = document.querySelector('.file-inner');
        if (!file) {
            nameEl.textContent = '';
            nameEl.style.display = 'none';
            innerEl.style.display = '';
            return;
        }
        nameEl.textContent = file.name;
        nameEl.style.display = '';
        innerEl.style.display = 'none';
    });

    // qa 확인버튼 클릭
    document.querySelector('.inquiry-wrap .btn-submit')?.addEventListener('click', () => {
        const form = document.getElementById('inquiryForm');
        const chk = formCheck($(form));

        if (!chk) return;

        if (!document.getElementById('inquiryAgree').checked) {
            alert('개인정보 이용약관에 동의해주세요.');
            return;
        }
        form.submit();
    });

    // 리저브 클럽 도입 상담문의
    $('.reservePopup .cancel').click((e) =>{
        $('form').each((i,v) => v.reset())
        $('.reservePopup textarea').text('')
    })

    $("#section").change((e) =>{
        let qaType = $(e.currentTarget).find(":selected").val()
        let cnt = `고객 고유번호 (카드앞면 알파벳 및 번호) : \n숙박권 (사용할 숙박권 뒷면 알파벳 및 번호) :\n객실타입 :\n인원수 (4인기준, 초과시 1박 인당 3만원) :\n입실일 :\n퇴실일 :\n문의 내용 :\n\n※ 사용불가일 : 공휴일 및 연휴 휴일전날, 징검다리연휴, 성수기, 특정일, 마감일 (변동될수있음)\n※ 모든내용 미 기재시 자동 문의 취소됩니다`
        // let cnt_2 = `- 호텔/시설명: \n- 위치: \n- 규모(객실수):`;
        switch (qaType) {
            case 'a':
                $('#rsvform textarea').text('');
                break;
            // case 'd':
            //     $('#rsvform textarea').text(cnt_2);
            //     break;
            default:
                $('#rsvform textarea').text(cnt);
                break;
        }
    })

    $('.guide-wrap .tab').click((e) => {
        $('.guide-wrap .tab').removeClass('active')
        let tabidx = $(e.currentTarget).addClass('active').index()
        $('.guide-wrap .guide').each((i,v) => i === tabidx ? $(v).show() : $(v).hide())
    })

    $('.membership-wrap #check_all').click((e) => {
        if($('#check_all').is(':checked')) {
            $('.check-list input:checkbox').prop('checked',true);
            // $('.check-list input:checkbox').val($(e.currentTarget).is(':checked') ? 'y' : '')
        }
    });

    $(".membership-wrap input[type=checkbox]").change((e) => {
        $(e.currentTarget).is(':checked') ? $(e.currentTarget).val('y') : $(e.currentTarget).val('')
    })

    $('#membership .btn-wrap').click(() => {
        let $form = $('#memform');
        const chk = formCheck($form)
        if(chk == true) {
            fetch('/reserve/membership', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
                },
                body: JSON.stringify({
                    name:  $('input[name=name]').val(),
                    tel:  $('input[name=tel]').val(),
                    email:  $('input[name=email]').val(),
                }),
            })
            .then((response) => response.json())
            .then((result) => {
                alert('리저브 클럽 멤버십 가입신청이 완료되었습니다.\n체인시설 할인 혜택을 가장 빠르고 간편하게 만나보세요!');
                //$('.reservePopup#membership').hide();
                location.reload();
            })
        }
    })

     $('.reservePopup .btn-partner').click((e) =>{
        let $form = $(e.currentTarget).parents('form');
        const chk = formCheck($form)
        if(chk == true) {
            $form.submit()
        }
    })

    // <---- booking ---->
    // 옵션 - + 버튼
    const UpDown = (e) => {
        let numInput = $(e.currentTarget).siblings('input')
        let numInputVal = +(numInput.val())
        numInputVal = numInputVal + $(e.currentTarget).data('calc')
        numInputVal < 0 ? numInput.val(0) : numInput.val(numInputVal)
    }

    // 달력
    let dayweek = ['일', '월', '화', '수', '목', '금', '토']
    let today = dayjs()
    let chkin = dayjs().format('YYYY-MM-DD')
    let chkout = dayjs().add(1, 'day').format('YYYY-MM-DD')
    const genCalendar = (today, body, type = 'non') => {
        const $calBody = $(body).find('.container');
        const $calTitle = $(body).find('.date-title');
        let now = dayjs(today)
        let firstDay = now.startOf("month").get('day');//달의 첫 요일
        let lastdate = now.endOf("month").get('date');//달의 마지막 일 28 or 30 or 31
        $($calTitle).find('span').text(`${now.get('y')}년 ${now.get('M')+1}월`)
        $calBody.empty();

        let html = '';
        let day = 1;

        $(html).appendTo($calBody)

        for(let i = 0; i < 42; i++){
            let calDay = `${now.format('YYYY-MM')}-${day < 10 ? '0' + day : day}`
            let dayCk = firstDay <= i && lastdate >= day
            $("<div class='day'>")
            .attr('data-dt',dayCk ? calDay : '' ) //data-dt 날짜 저장
            .addClass(dayjs(calDay).isBefore(dayjs().format('YYYY-MM-DD')) && dayCk ? 'off' : '' ) //오늘날짜 이전 off 추가
            .addClass(calDay === chkin && dayCk ? 'chkin' : '') //오늘 or 선택 날짜 chkin 추가
            .addClass(dayjs(calDay).isBetween(chkin, chkout) && dayCk ? 'slt' : '') //slt 클래스 추가
            .addClass(calDay === chkout && dayCk ? 'chkout' : '') //chkout 추가
            .addClass(dayjs(calDay).get('day') === 0 && dayCk ? 'sun' : dayjs(calDay).get('day') === 6 && dayCk  ? 'sat' : '' ) // 토,일 추가
            .html(dayCk ? day < 10 ? '0' + day++ : day++ : '')
            .append(dayCk ?  type === 'non' ? '' : '<span class="prc">10,000</span>' : '')
            .appendTo($calBody)
        }
        return html;
    }

    const dayClick = (e) =>{
        let $curTarget = $(e.currentTarget)
        let $cnt = $($curTarget).parents('.popup-cnt')
        let $day = $($cnt).find('.day')
        let chkinDT  = $($cnt).find('.day.chkin').data('dt')
        let curDT = $curTarget.data('dt')
        if(!$curTarget.hasClass('off') && $curTarget.text()){
            // 체크아웃 선택시
            if($($cnt).find('.day.chkin').length > 0 && $($cnt).find('.day.chkout').length == 0 && dayjs(chkinDT).isBefore(curDT)) { //체그아웃 존재 하지않고 선택한 날짜가 체크인 이후일 경우
                dayjs(curDT).diff(dayjs(chkinDT), 'd') > 15 ?
                alert('해당상품은 15박이상 예약불가능합니다.')
                : $($cnt).find($('.off')).toArray().every(v => !dayjs($(v).data('dt')).isBetween(chkinDT, curDT)) ? //선택날짜중에 마감일 체크
                $day.each((i, v) => {
                    $(v).addClass(dayjs($(v).data('dt')).isBetween(chkinDT, curDT) ? 'slt' : '') //선택한 날짜들 slt 추가
                    $curTarget.addClass('chkout')
                    chkout = curDT
                })
                : alert('이용기간 중 마감날짜가 포함되어 있습니다.')
                setDay(chkinDT, chkout)
            }else{//체크인 선택시
                $day.removeClass('chkin chkout slt')
                $curTarget.addClass('chkin')
                chkin = curDT
                chkout = ''
            }
        }

        let chkinDay = `${chkinDT}(${dayweek[dayjs(chkinDT).get('d')]})`
        let chkoutDay = `${chkout}(${dayweek[dayjs(chkout).get('d')]})`
        let diffDay = `${dayjs(chkout).diff(dayjs(chkinDT), "day")}`

        if($($cnt).parents('.calendarScroll')){
            if(chkout === ''){
                $('.popup-title span').text('체크아웃 날짜를 선택해주세요.')
            }else{
                $('.popup-title span').text(`${chkinDay} ~ ${chkoutDay} / ${diffDay}박`)
            }
        }
    }

    const setDay = (chkin, chkout) => {
        let chkinDay = `${chkin}(${dayweek[dayjs(chkin).get('d')]})`
        let chkoutDay = `${chkout}(${dayweek[dayjs(chkout).get('d')]})`
        let diffDay = `${dayjs(chkout).diff(dayjs(chkin), "day")}`
        $('.booking-wrap .head-checkin .date').text(`${chkinDay}`)
        $('.booking-wrap .head-checkout .date').text(`${chkoutDay}`)
        $('.booking-wrap .tab-head .num').text(`${diffDay}박`)
        $('.popup-title span').text(`${chkinDay} ~ ${chkoutDay} / ${diffDay}박`)

        // pc
        $('.booking-wrap .tab-head .date p').text(`[${chkinDay}]`)
        $('.booking-wrap .tab .prd-chkin').val(chkin)
        $('.booking-wrap .tab .prd-chkout').val(chkout)
        $('.booking-wrap .tab .prd-night').val(diffDay)
    }

    setDay(chkin, chkout)

    // 웹 달력
    let calType = ''
    $('.btn-cal').click((e) => {
        let thisbtn = $(e.currentTarget).data('mode')
        calType =  $(e.currentTarget).data('type') || calType
        if(thisbtn){
            today = $(e.currentTarget).data('mode') === 'add' ? today.add(1, "M") : today.add(-1, "M") //이전 다음 달력 버튼 비교
        }else{
            today = dayjs(chkin)
        }
        genCalendar(today, '.calendar-wrap.prev', calType)
        genCalendar(today.add(1, "M"), '.calendar-wrap.next', calType)
        $('.calendar-wrap.prev .btn-cal').css('display',today.get('M') === dayjs().get('M')? 'none' : 'block')

        $('.popup-cnt .day').click((e) => dayClick(e))
    })

    $(".tab-head .btn-cal").trigger("click");

    $('.booking-wrap .prd-night').change((e) => {
        let pday = $('.tab.active .prd-chkin').val()
        let pnight = $(e.currentTarget).val()
        chkout = dayjs(pday).add(pnight, "day").format('YYYY-MM-DD')
        $('.prd-chkout').val(chkout)
        $('.booking-wrap .tab .prd-night').val(pnight)
    })

    $('.sideBanner.booking .btn-help').click((e) =>{
        const $form = $('#help');
        formCheck($form);
    })

    $('.booking-wrap .tab-list .tab').click((e) =>{
        if(!$(e.currentTarget).hasClass('closed')){
            $('.booking-wrap .tab-list .tab').removeClass('active')
            $(e.currentTarget).addClass('active').find('input[type=radio]').prop('checked', true);
        }else{
            alert('예약마감된 객실입니다.')
        }
    })

    const pkgCheck = (pkgTitle) =>{
        let $ckbox = pkgTitle.find('input[type=checkbox]').toArray();
        let prdCnt = pkgTitle.closest('.prd-cnt')

        if($ckbox.every((v) => !($(v).is(':checked')))){
            prdCnt.find('.pkg-prc').hide()
            prdCnt.find('.prd-pay .total-pay').hide()
            prdCnt.find('.prd-pay .pay').show()
        }else{
            prdCnt.find('.pkg-prc').show()
        }
    }

    $('.booking-wrap .prd-title').click((e) =>{
        $('.booking-wrap .pkg-tit').toArray().map(v => {
            $(v).find('input').prop('checked',false).val('')
            $(v).removeClass('active').next().removeClass('active')
            $(v).next().find('.opt-wrap .num input').toArray().map(opt => {
                $(opt).val(0)
            })
        })
        pkgCheck($('.booking-wrap .prd-title'))

        if($(e.currentTarget).hasClass('active')){
            $('.booking-wrap .prd-title').removeClass('active')
            $('.booking-wrap .prd-cnt').hide()
        }else{
            $('.booking-wrap .prd-title').removeClass('active')
            $('.booking-wrap .prd-cnt').hide()
            $(e.currentTarget).addClass('active')
            $(e.currentTarget).siblings('.prd-cnt').show()
        }
    })

    $('.booking-wrap .pkg-tit input[type=checkbox]').click((e) =>{
        let pkgCk = $(e.currentTarget)
        let pkgTitle = pkgCk.parent()
        let $optCkbow = pkgTitle.siblings().find('.opt-wrap .prc input').toArray()

        if(pkgCk.is(':checked')){
            pkgTitle.addClass('active').next().addClass('active')
        }else{
            pkgTitle.removeClass('active').next().removeClass('active')
            $optCkbow.map(v => $(v).val(0))
        }
        pkgCheck(pkgTitle)
    })

    $('.booking-wrap .opt-wrap .num .btn').click((e) => {
        UpDown(e);
        let $pkgnum = $('.booking-wrap .opt-wrap .prc input').toArray()
        let prdCnt = $(e.currentTarget).closest('.prd-cnt')
        if($pkgnum.some((v) => +$(v).val() > 0)){
            prdCnt.find('.prd-pay .total-pay').show()
            prdCnt.find('.prd-pay .pay').hide()
        } else{
            prdCnt.find('.prd-pay .total-pay').hide()
            prdCnt.find('.prd-pay .pay').show()
        }
    })

    $('.booking-wrap .gallery li').click((e)=> {
        $('.galleryPopup').show()
        let $gallery = $(e.currentTarget).closest('.gallery').prevUntil('.info-wrap')
        let num = $gallery.find('li').length
        let idx = $(e.currentTarget).index() + num
        Swipers[0].slideTo(idx)
    })

    $('.reservation-wrap .pay-wrap input[type=radio]').change((e) => {
        let pay = $(e.currentTarget).attr('id')
        $('.reservation-wrap .comment .comt').hide()
        $(`.reservation-wrap .comment .${pay}`).show()
        $(`.pay_va input`).attr('data-optional', pay === 'pay_va' ? '' : 'skip')
    })

    /**
     * 결제하기 버튼 클릭 시 처리
     */
    $(".reservation-wrap .btn-payment").click(() => {
        const $form = $('#rsv');
        const valide = formCheck($form);

        const plaform = $(".reservation-wrap .btn-payment").data('plaform');  //모바일/PC 분기

        if (valide == true) {
            if (plaform == 'mobile') {
                $('#stayname').val($('#reserve_name').val());
                $form.submit();
            } else {
                $('#reserve_name').val($('#stayname').val());
                $form.submit();
                // window.name = "reservation_02";
                // const payWin = window.open("/booking/paymentPopupPC", "payment", "toolbar=no,scrollbars=yes,directories=no,status=no,menubar=no,width=400,height=650,resizable=yes, top=50, left="+((screen.width - 450)/2)+"");
                // $form.attr({"target": "payment", "action": "/booking/paymentPopupPC"}).submit();
                // payWin.focus();
            }
        }
    })

    $(".reservation-wrap .check-all").change((e) => {
        $('.check-list input[type=checkbox]').each((i,v) =>{
            $(v).prop("checked",$(e.currentTarget).is(':checked'))
            $(v).val($(e.currentTarget).is(':checked') ? 'y' : '')
        })
    })

    $(window).scroll(() => {
        $('.sideBanner.booking').removeClass('active');
        if($(window).scrollTop() > 200) $('.sideBanner.booking').addClass('active');
    })

    // 예약 모바일

    // 달력
    $('.booking-wrap .room-wrap .tab-head').click((e) => {
        $('.calendarScroll .calendar-wrap').each((i, v) => {
            genCalendar(dayjs().add(i, "M"), v)
            $(v).find('.day').each((i, v) => {if($(v).text() === '')$(v).css('background-color', '#fff')})
        })
        $('.popup-cnt .day').click((e) => dayClick(e))
    })
    $('.calendarScroll .close-btn, .calendarScroll .btn-choice').click((e) => {
        if(chkout ===''){
            alert('체크아웃 날짜를 선택하세요.')
        }else{
            $('#cal_m').hide();
        }
    })

    // 모바일 click이벤트 오류
    $('.booking-wrap .list-wrap .tab').on('touchend, mouseup',(e) => {
        if(!$(e.currentTarget).hasClass('closed')){
            $('.booking-wrap .list-wrap .choice-wrap').hide()
            $(e.currentTarget).find('.choice-wrap').show()
            $('.booking-wrap .list-wrap .tab').removeClass('active')
            $(e.currentTarget).addClass('active').find('input[type=radio]').prop('checked', true);
        }else{
            alert('예약마감된 객실입니다.')
        }
    })

    $('.reservation-wrap .paytype').click((e) => {
        $('.reservation-wrap .paytype').removeClass('active')
        $(e.currentTarget).addClass('active')
        $('.reservation-wrap input[name=pay_type]').val($(e.currentTarget).data('type'))
    })

    // -----------------------------------
    // 리저브 클럽 관련 javascript
    // -----------------------------------

    // 카드발급 요청
    $('#btn-reserve-club-card').on('click', function () {
        var name = $('#card_name').val();
        var tel = $('#card_phone').val();
        var email = $('#card_mail').val();

        var chk = $('#card_agree').is(':checked');

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#card_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#card_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#card_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#cardform').submit();
    });

    // 명의개서 요청
    $('#btn-reserve-club-trans').on('click', function () {
        var name = $('#trn_name').val();
        var tel = $('#trn_phone').val();
        var email = $('#trn_mail').val();

        var chk = $('#trn_agree').is(':checked');

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#trn_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#trn_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#trn_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#trnform').submit();
    });

    // 1:1 문의하기 "확인" 처리
    $('#btn-reserve-club-inquire').on('click', function () {
        var section = $('#section option:selected').val();
        var name = $('#inquire_name').val();
        var tel = $('#inquire_tel').val();
        var email = $('#inquire_email').val();
        var contents = $('#reserve-club-inquire-contents').val();

        var chk = $('#popup_agree').is(':checked');

        if (section == '') {
            alert('질문 분류를 선택해주세요.');
            return;
        }

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#inquire_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#inquire_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#inquire_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#rsvform').submit();
    });

    // -------------------------------------
    // 단체문의 시 필수 데이터 체크
    // -------------------------------------
    $('#btn-group-ask-run').on('click', function() {
        if ($(this).prop('disabled')) return;

        //필수 데이터 체크
        var name = $('#name').val();
        var tel1 = $('#tel1').val();
        var tel2 = $('#tel2').val();
        var tel3 = $('#tel3').val();
        var email = $('#email').val();

        if (name == '') {
            alert('예약자를 입력해 주세요.');
            $('#name').focus();
            return;
        }

        if (tel1 == '') {
            alert('연락처 앞 부분을 입력해 주세요.');
            $('#tel1').focus();
            return;
        }

        if (/^\d{2,3}$/.test(tel1) == false) {
            alert('연락처 앞 부분이 유효하지 않습니다.');
            $('#tel1').focus();
            return;
        }

        if (tel2 == '') {
            alert('연락처 중간 부분을 입력해 주세요.');
            $('#tel2').focus();
            return;
        }

        if (/^\d{4}$/.test(tel2) == false) {
            alert('연락처 중간 부분이 유효하지 않습니다.');
            $('#tel2').focus();
            return;
        }

        if (tel3 == '') {
            alert('연락처 마지막 부분을 입력해 주세요.');
            $('#tel3').focus();
            return;
        }

        if (/^\d{4}$/.test(tel3) == false) {
            alert('연락처 마지막 부분이 유효하지 않습니다.');
            $('#tel3').focus();
            return;
        }

        if (email == '') {
            alert('이메일을 입력해 주세요.');
            $('#email').focus();
            return;
        }

        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (regex.test(email) == false) {
            alert('이메일 형식이 유효하지 않습니다.');
            $('#email').focus();
            return;
        }

        //통과 후 form 전송
        $(this).prop('disabled', true);
        $('#grpform').submit();
    });

    // 예약내역 조회
    $('.history-wrap .tab').on('click', 'li',(e) =>{
        let idx = $(e.currentTarget).index()
        $('.history-wrap .tab li').removeClass('active')
        $(e.currentTarget).addClass('active')

        $('.history-wrap .section>li').hide()
        $('.history-wrap .section>li').eq(idx).show()
    })

    $(".btn-copy").on("click", function() {
        const text = $(this).data("copy").trim();
        navigator.clipboard.writeText(text).then(() => alert('주소가 복사 되었습니다.\n원하는 곳에 붙여넣기 해주세요.'));
    });

    /**
     * 영수증발급/호텔바우처 클릭 이벤트 처리
     */
    $('.btn-receipt-voucher').on('click', function (e) {
        e.preventDefault();

        const type = $(this).data('type');
        const orderNo = $(this).data('no');

        const width = (type == 'voucher') ? 800 : 420;

        // 팝업 창 열기 (빈 새 창 생성)
        const popup = window.open('', 'popup', 'width='+width+',height=800');

        // 타입 별 action 지정
        const action = (type == 'voucher') ? '/booking/voucher' : '/booking/receipt';

        // 동적 폼 생성
        const form = $('<form>', { method: 'POST', action: action, target: 'popup' });

        // CSRF 토큰이 필요하면 여기에 추가
        form.append($('<input>', { type: 'hidden', name: '_token', value: $('meta[name="csrf-token"]').attr('content') }));

        // 주문번호 추가
        form.append($('<input>', { type: 'hidden', name: 'order_no', value: orderNo }));

        $('body').append(form);
        form.submit();
    });

    /**
     * 호텔바우처 메일 발송 처리
     */
    $('#btn-voucher-send-mail').on('click', function (e) {
        e.preventDefault();

        const orderNo = $(this).data('no');

        $.ajax({
            url: '/booking/voucherSendmail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {order_no: orderNo},
            dataType: 'json',
            success: function(response) {
                if (response.res == '200') {
                    alert('메일이 발송되었습니다.');
                } else {
                    alert('메일 발송이 실패했습니다.\r\n잠시후에 다시 시도해주세요.');
                }
            },
            error: function(xhr, status, error) {
                alert('메일 발송이 실패했습니다.\r\n잠시후에 다시 시도해주세요.');
            }
        });
    });

    /**
     * PC 결제수단 선택 시, 이벤트 처리
     *
     * 네이버페이 쿠폰 진입 인 경우에 대해서만 처리하면 됨.
     * 네이버페이 선택 시 10% 할인금액 적용하고, 기타 결제수단 선택 시 기본요금으로 원상복구 처리
     */
    $(document).on('click', 'input[name="pay_type"]', function () {
        const from_npay = $('#from_npay').val();

        if (from_npay == 'Y') {  //네이버페이 쿠폰으로 진입된 경우만 처리 함
            const pay_type = $(this).val();
            const final_price = $('#read_final_price').val();
            const npay_price = $('#read_npay_price').val();
            const estring = $('#read_estring').val();
            const estring_npay = $('#read_estring_npay').val();

            if (pay_type == 'npay') {  //결제수단: 네이버페이
                $('#money').val(npay_price);
                $('#final_price').text(npay_price);
                $('#estring').val(estring_npay);
                $('#npay-sale-info').show();
                $('#pid').val('npay_coupon');

            } else {  //결제수단: 기타
                $('#money').val(final_price);
                $('#final_price').text(final_price);
                $('#estring').val(estring);
                $('#npay-sale-info').hide();
                $('#pid').val('ocean2you_home');
            }
        }
    });

    /**
     * 모바일 결제수단 선택 시, 이벤트 처리
     *
     * 네이버페이 쿠폰 진입 인 경우에 대해서만 처리하면 됨.
     * 네이버페이 선택 시 10% 할인금액 적용하고, 기타 결제수단 선택 시 기본요금으로 원상복구 처리
     */
    $(document).on('click', '.paytype', function () {
        const from_npay = $('#from_npay').val();

        if (from_npay == 'Y') {  //네이버페이 쿠폰으로 진입된 경우만 처리 함
            const pay_type = $(this).data('type');
            const final_price = $('#read_final_price').val();
            const npay_price = $('#read_npay_price').val();
            const estring = $('#read_estring').val();
            const estring_npay = $('#read_estring_npay').val();

            if (pay_type == 'npay_mobile') {  //결제수단: 네이버페이
                $('#money').val(npay_price);
                $('#final_price').text(npay_price);
                $('#estring').val(estring_npay);
                $('#npay-sale-info').show();
                $('#pid').val('npay_coupon');

            } else {  //결제수단: 기타
                $('#money').val(final_price);
                $('#final_price').text(final_price);
                $('#estring').val(estring);
                $('#npay-sale-info').hide();
                $('#pid').val('ocean2you_home');
            }
        }
    });

    // 쿠폰 sessionStorage 헬퍼
    const COUPON_SESSION_KEY = 'o2uCoupon';

    const saveCouponSession = (couponData) => {
        sessionStorage.setItem(COUPON_SESSION_KEY, JSON.stringify(couponData));
    };

    const clearCouponSession = () => {
        sessionStorage.removeItem(COUPON_SESSION_KEY);
    };

    const restoreCouponSession = () => {
        if (!document.querySelector('#rsv')) return;

        const saved = sessionStorage.getItem(COUPON_SESSION_KEY);
        if (!saved) return;

        let data;
        try { data = JSON.parse(saved); } catch { clearCouponSession(); return; }

        const isNpay = document.querySelector('#from_npay').value === 'Y';
        const originalEstring = document.querySelector(isNpay ? '#read_estring_npay' : '#read_estring').value;

        if (data.original_estring !== originalEstring) {
            clearCouponSession();
            return;
        }

        const formatNum = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        document.querySelector('.input-coupon').value = data.coupon_code_input ?? '';
        document.querySelector('#coupon-sale-info .txtRed').textContent = '-' + formatNum(data.discount_amount) + '원';
        document.querySelector('#coupon-sale-info').style.display = '';
        document.querySelector('#final_price').innerHTML = formatNum(data.final_price) + ' <span>원</span>';
        document.querySelector('#money').value = formatNum(data.final_price);
        document.querySelector('#estring').value = data.applied_estring;

        const form = document.querySelector('#rsv');
        ['coupon_id', 'coupon_list_id', 'coupon_name', 'coupon_code'].forEach(key => {
            form.querySelector(`input[name="${key}"]`).value = data[key] ?? '';
        });

        document.querySelector('.btn-apply-coupon').textContent = '쿠폰취소';
    };

    const cancelCoupon = () => {
        const isNpay = document.querySelector('#from_npay').value === 'Y';
        const currentPrice = parseInt(document.querySelector(isNpay ? '#read_npay_price' : '#read_final_price').value.replace(/,/g, ''), 10);
        const estring = document.querySelector(isNpay ? '#read_estring_npay' : '#read_estring').value;
        const formatNum = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        document.querySelector('.input-coupon').value = '';
        document.querySelector('#coupon-sale-info').style.display = 'none';
        document.querySelector('#coupon-sale-info .txtRed').textContent = '';
        document.querySelector('#final_price').innerHTML = formatNum(currentPrice) + ' <span>원</span>';
        document.querySelector('#money').value = formatNum(currentPrice);
        document.querySelector('#estring').value = estring;

        const form = document.querySelector('#rsv');
        ['coupon_id', 'coupon_list_id', 'coupon_name', 'coupon_code'].forEach(key => {
            form.querySelector(`input[name="${key}"]`).value = '';
        });

        document.querySelector('.btn-apply-coupon').textContent = '쿠폰적용';
        clearCouponSession();
    };

    // 페이지 로드 시 쿠폰 상태 복원
    restoreCouponSession();

    // 쿠폰 적용/취소 버튼
    $(".btn-apply-coupon").on("click", () => {
        if (document.querySelector('.btn-apply-coupon').textContent.trim() === '쿠폰취소') {
            cancelCoupon();
            return;
        }

        const code = document.querySelector('.input-coupon').value.trim();

        if (!code) {
            alert('쿠폰 번호를 입력해주세요.');
            return;
        }

        const formatNum    = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const isNpay       = document.querySelector('#from_npay').value === 'Y';
        const currentPrice = parseInt(document.querySelector(isNpay ? '#read_npay_price' : '#read_final_price').value.replace(/,/g, ''), 10);
        const estring      = document.querySelector(isNpay ? '#read_estring_npay' : '#read_estring').value;

        fetch('/ajax/coupon/check', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
            body: JSON.stringify({ code: code, current_price: currentPrice, estring: estring }),
        })
            .then(res => res.json())
            .then(data => {
                alert(data.msg);

                if (data.result === 'ok') {
                    document.querySelector('#coupon-sale-info .txtRed').textContent = '-' + formatNum(data.discount_amount) + '원';
                    document.querySelector('#coupon-sale-info').style.display = '';
                    document.querySelector('#final_price').innerHTML = formatNum(data.final_price) + ' <span>원</span>';
                    document.querySelector('#money').value = formatNum(data.final_price);
                    document.querySelector('#estring').value = data.estring;

                    const form = document.querySelector('#rsv');
                    ['coupon_id', 'coupon_list_id', 'coupon_name', 'coupon_code'].forEach(key => {
                        form.querySelector(`input[name="${key}"]`).value = data[key] ?? '';
                    });

                    saveCouponSession({
                        original_estring:  estring,
                        applied_estring:   data.estring,
                        coupon_id:         data.coupon_id,
                        coupon_list_id:    data.coupon_list_id,
                        coupon_name:       data.coupon_name,
                        coupon_code:       data.coupon_code,
                        coupon_code_input: code,
                        discount_amount:   data.discount_amount,
                        final_price:       data.final_price,
                    });
                    document.querySelector('.btn-apply-coupon').textContent = '쿠폰취소';
                } else {
                    cancelCoupon();
                }
            })
            .catch(() => {
                alert('오류가 발생했습니다. 다시 시도해주세요.');
            });
    });

});
